/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessReviewSession'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BusinessReviewSession'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewSessionPaginationSlice = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessReviewSession);
  }
}(this, function(ApiClient, BusinessReviewSession) {
  'use strict';




  /**
   * The BusinessReviewSessionPaginationSlice model module.
   * @module model/BusinessReviewSessionPaginationSlice
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessReviewSessionPaginationSlice</code>.
   * @alias module:model/BusinessReviewSessionPaginationSlice
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>BusinessReviewSessionPaginationSlice</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessReviewSessionPaginationSlice} obj Optional instance to populate.
   * @return {module:model/BusinessReviewSessionPaginationSlice} The populated <code>BusinessReviewSessionPaginationSlice</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Count')) {
        obj['Count'] = ApiClient.convertToType(data['Count'], 'Integer');
      }
      if (data.hasOwnProperty('TotalCount')) {
        obj['TotalCount'] = ApiClient.convertToType(data['TotalCount'], 'Integer');
      }
      if (data.hasOwnProperty('Order')) {
        obj['Order'] = ApiClient.convertToType(data['Order'], 'Integer');
      }
      if (data.hasOwnProperty('NewCount')) {
        obj['NewCount'] = ApiClient.convertToType(data['NewCount'], 'Integer');
      }
      if (data.hasOwnProperty('NextID')) {
        obj['NextID'] = ApiClient.convertToType(data['NextID'], 'Integer');
      }
      if (data.hasOwnProperty('Data')) {
        obj['Data'] = ApiClient.convertToType(data['Data'], [BusinessReviewSession]);
      }
    }
    return obj;
  }

  /**
   * @member {Integer} Count
   * @default 0
   */
  exports.prototype['Count'] = 0;
  /**
   * @member {Integer} TotalCount
   * @default 0
   */
  exports.prototype['TotalCount'] = 0;
  /**
   * @member {Integer} Order
   * @default 0
   */
  exports.prototype['Order'] = 0;
  /**
   * @member {Integer} NewCount
   * @default 0
   */
  exports.prototype['NewCount'] = 0;
  /**
   * @member {Integer} NextID
   * @default 0
   */
  exports.prototype['NextID'] = 0;
  /**
   * @member {Array.<module:model/BusinessReviewSession>} Data
   */
  exports.prototype['Data'] = undefined;



  return exports;
}));


